export const ABOUT_ME_ITEMS = [
  {
    linkTo: "/about-me/main-info",
    linkName: "Основна информация",
  },
  {
    linkTo: "/about-me/education",
    linkName: "Образование",
  },
  {
    linkTo: "/about-me/qualification",
    linkName: "Квалификация",
  },
  {
    linkTo: "/about-me/courses",
    linkName: "Курсове",
  },
  {
    linkTo: "/about-me/future-plans",
    linkName: "Бъдещи планове",
  },
  {
    linkTo: "/about-me/philosophy",
    linkName: "Философия",
  },
];

export const STUDENTS_ITEMS = [
  {
    linkTo: "/students/self-preparation",
    linkName: "Самоподготовка",
  },
  {
    linkTo: "/students/interests",
    linkName: "Занимания по интереси",
  },
  {
    linkTo: "/students/recreation-and-sports",
    linkName: "Организиран отдих и спорт",
  },
];

export const GALLERY_ITEMS = [
  {
    linkTo: "/gallery/1-g",
    linkName: "ГЦОУД 1”Г”",
  },
  {
    linkTo: "/gallery/buditeli-24",
    linkName: "01.11.2024г.	Ден на народните будители",
  },
  {
    linkTo: "/gallery/tolerant-24",
    linkName: "16.11.2024г. Ден на толерантността",
  },
  {
    linkTo: "/gallery/christ-family",
    linkName: "21.11.2024г. Ден на християнското семейство",
  },
  {
    linkTo: "/gallery/me-and-my-dad",
    linkName: "09.12.2024г. Аз и моя татко",
  },
  {
    linkTo: "/gallery/baba-marta",
    linkName: "Баба Марта",
  },
  {
    linkTo: "/gallery/dg-zdravec",
    linkName: "21.03.2025г. Пролетни цветя -посещение на ДГ „Здравец“",
  },
  {
    linkTo: "/gallery/tarpenie",
    linkName: "25.03.2025г. Благовещение -Ден на търпението",
  },
  {
    linkTo: "/gallery/prikaznite-geroi",
    linkName: "14.04.2025г. Парад на приказните герои",
  },
  {
    linkTo: "/gallery/earth-day-25",
    linkName: "22.04.2025г. - Световен ден на Земята",
  },
  {
    linkTo: "/gallery/bdp-competition",
    linkName: "28.04.2025г. Състезание БДП",
  },
  {
    linkTo: "/gallery/drawings",
    linkName: "30.04.2025г. Рисунка на асфалт",
  },
  {
    linkTo: "/gallery/24-may-25",
    linkName: "24.05.2025г. Ден на славянската писменост и култура",
  },
  {
    linkTo: "/gallery/4-v-b",
    linkName: "ГЦОУД 4”В,Б”",
  },
  {
    linkTo: "/gallery/3-v-b",
    linkName: "ГЦОУД 3”В,Б”",
  },
  {
    linkTo: "/gallery/2-v",
    linkName: "ГЦОУД 2“В“",
  },
  {
    linkTo: "/gallery/buditeli",
    linkName: "01.11.2023г. Ден на народните будители",
  },
  {
    linkTo: "/gallery/bg-artist",
    linkName: "03.11.2023г. Ден на българския художник",
  },
  {
    linkTo: "/gallery/word-day-23",
    linkName: "11.01.2023г. Световен ден на думата Благодаря",
  },
  {
    linkTo: "/gallery/tolerant",
    linkName: "16.11.2023г. Ден на толерантността",
  },
  {
    linkTo: "/gallery/earth-day-24",
    linkName: "22.04.2024г. - Световен ден на Земята",
  },
  {
    linkTo: "/gallery/fairy-tail",
    linkName: "14.12.2023г.Бабо разкажи ми приказка",
  },
  {
    linkTo: "/gallery/christmass-factory",
    linkName: "Коледна работилничка",
  },
  {
    linkTo: "/gallery/earth-day-26",
    linkName:
      "ГЦОУД 2.г клас - 'Ние ще пазим Земята!'- 100 начина да спасим Земята",
  },
  {
    linkTo: "/gallery/kids-day",
    linkName: "01.06.2026г. Ден на детето - 2026",
  },
  {
    linkTo: "/gallery/24-may-26",
    linkName: "24.05.2026г",
  },
  {
    linkTo: "/gallery/shoko-day",
    linkName: "16.05.2026г. – Празник на шоколада",
  },
  {
    linkTo: "/gallery/patiece-day",
    linkName: "25.03.2026г. Ден на търпението и Благовещение",
  },
  {
    linkTo: "/gallery/granny-tell-me-story",
    linkName: "12.01.2026г- Бабо разкажи ми приказка",
  },
  {
    linkTo: "/gallery/word-day-26",
    linkName: "11.01.2026г.Световен ден на думата Благодаря – открит урок",
  },
  {
    linkTo: "/gallery/workshop",
    linkName: "21.11.25г.",
  },
  {
    linkTo: "/gallery/sport-week",
    linkName: "Седмица на спорта",
  },
  {
    linkTo: "/gallery/15-09-25",
    linkName: "15.09.2025г.",
  },
];
